var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 200,
    viewBox: "0 0 282 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6175_264672)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 200,
    rx: 12,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141 79C142.657 79 144 77.6569 144 76C144 74.3431 142.657 73 141 73C139.343 73 138 74.3431 138 76C138 77.6569 139.343 79 141 79ZM147 76C147 79.3137 144.314 82 141 82C137.686 82 135 79.3137 135 76C135 72.6863 137.686 70 141 70C144.314 70 147 72.6863 147 76Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.5 67C147.364 67 146.325 66.358 145.817 65.3416L145.56 64.8292C145.306 64.321 144.787 64 144.219 64H137.781C137.213 64 136.694 64.321 136.44 64.8292L136.183 65.3416C135.675 66.358 134.636 67 133.5 67H130.5C129.672 67 129 67.6716 129 68.5V83.5C129 84.3284 129.672 85 130.5 85H151.5C152.328 85 153 84.3284 153 83.5V68.5C153 67.6716 152.328 67 151.5 67H148.5ZM148.5 64L148.244 63.4875C147.482 61.963 145.923 61 144.219 61H137.781C136.077 61 134.518 61.963 133.756 63.4875L133.5 64H130.5C128.015 64 126 66.0147 126 68.5V83.5C126 85.9853 128.015 88 130.5 88H151.5C153.985 88 156 85.9853 156 83.5V68.5C156 66.0147 153.985 64 151.5 64H148.5Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 70.75C150.75 71.5784 150.078 72.25 149.25 72.25C148.422 72.25 147.75 71.5784 147.75 70.75C147.75 69.9216 148.422 69.25 149.25 69.25C150.078 69.25 150.75 69.9216 150.75 70.75Z",
    fill: "#6F767E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6175_264672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 200,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraLight);
export default __webpack_public_path__ + "static/media/camera_Light.9d75f7d1cb1f1304437721117845a36c.svg";
export { ForwardRef as ReactComponent };